	// src/services/auth.js
	import axios from 'axios';

	const API_URL = 'https://api.weartoday.kr/api/users';

	export const login = async (credentials) => {
		try {
			const response = await axios.post(`${API_URL}/login/`, credentials);
			
			if (response.data.access) {
				localStorage.setItem('access_token', response.data.access);
				localStorage.setItem('refresh_token', response.data.refresh);
				localStorage.setItem('user', JSON.stringify(response.data.user));
			}
			
			return response.data;
		} catch (error) {
			console.error('🔥 auth.js login 에러:', error);
			throw error;
		}
	};

	export const register = async (userData) => {
		try {
			const response = await axios.post(`${API_URL}/register/`, userData);
			
			if (response.data.access) {
				localStorage.setItem('access_token', response.data.access);
				localStorage.setItem('refresh_token', response.data.refresh);
				localStorage.setItem('user', JSON.stringify(response.data.user));
			}
			
			return response.data;
		} catch (error) {
			throw error;
		}
	};

	export const logout = () => {
		localStorage.removeItem('access_token');
		localStorage.removeItem('refresh_token');
		localStorage.removeItem('user');
	};

	export const isAuthenticated = () => {
		const token = localStorage.getItem('access_token');
		return !!token;
	};

	export const getToken = () => {
		return localStorage.getItem('access_token');
	};

	export const getCurrentUser = () => {
		const userStr = localStorage.getItem('user');
		if (userStr) {
			return JSON.parse(userStr);
		}
		return null;
	};

	// 🔥 언더스코어(_) → 하이픈(-) 수정 (원래대로)
	export const checkUsername = async (username) => {
		try {
			const response = await axios.get(`${API_URL}/check-username/`, {
				params: { username }
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	};

	// 🔥 언더스코어(_) → 하이픈(-) 수정 (원래대로)
	export const checkEmail = async (email) => {
		try {
			const response = await axios.get(`${API_URL}/check-email/`, {
				params: { email }
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	};